import React from "react";

interface SiteFooterProps {
    className?: string;
}

export default function SiteFooter({ className = "" }: SiteFooterProps) {
    return (
        <section className={`pb-12 text-center flex flex-col items-center ${className}`}>
            {/* TikTok Social Link */}
            <div className="mt-8 flex flex-col items-center gap-4 animate-fade-in-delayed">
                <a
                    href="https://www.tiktok.com/@hikari.mana.xoxo"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex flex-col items-center gap-3"
                >
                    <div className="relative w-16 h-16 rounded-full overflow-hidden border border-neutral-300 group-hover:border-neutral-800 group-hover:scale-105 transition-all duration-500">
                        <img
                            src="/media/Persona_Hero_Portrait_Alternative.jpeg"
                            alt="Hikari TikTok"
                            className="w-full h-full object-cover filter grayscale group-hover:grayscale-0 transition-all duration-500"
                        />
                    </div>
                    <span className="font-sans text-[10px] tracking-[0.2em] uppercase text-neutral-500 group-hover:text-neutral-900 transition-colors duration-300">
                        @hikari.mana.xoxo
                    </span>
                </a>
            </div>

            <footer className="py-12 border-t border-neutral-300 w-full max-w-xl mt-8 space-y-6">
                <p className="font-display text-lg text-neutral-800">Hikari Mana — Creative Partner, Curator of Quiet.</p>
                <p className="text-[10px] text-neutral-400 font-sans">© {new Date().getFullYear()} Hikari Mana. All rights reserved.</p>
            </footer>
        </section>
    );
}
